var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"page-wrap DeviceList-page"},[_c('Search',{ref:"search",attrs:{"label":_vm.searchLabel,"dateFilter":false},on:{"search":_vm.search}}),_c('List',{ref:"list",attrs:{"title":"物料列表","refresh":true,"label":_vm.label,"apiName":"petMaterialList"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }